<div class="link-response">
  <h1 class="link-response__header">Seleccionar operaciones</h1>
  <div *ngIf="!isEmailThreadFound">
    <app-autocomplete label="Busca por RUC o Nombre del deudor*" (OnSelectionChanged)="searchByDebtor($event)" searchFor="debtor"></app-autocomplete>
  </div>
  <div class="link-response__list">
    <div
      class="link-response__card"
      [ngClass]="{
        'link-response__card--selected': selectedIndexes.has(index)
      }"
      *ngFor="let operation of operations; let index = index"
    >
      <div class="link-response__actions">
        <div class="link-response__actions--button">
          <app-checkbox
            [checked]="false"
            (selectionChanged)="toggleSelection(index)"
            [disabled]="!contactsValidation?.validFrom"
            type="blue_checked"
          ></app-checkbox>
          <lib-text
            size="xs"
            weight="label"
            [content]="'Seleccionado'"
          ></lib-text>
        </div>
        <div
          class="link-response__actions--button-link pointer"
          (click)="goToDetail(index)"
        >
          <lib-icon color="blue" class="right-space" icon="open_new"></lib-icon>
          <lib-text
            color="blue"
            size="xs"
            weight="label"
            [content]="'Revisar operación'"
          >
          </lib-text>
        </div>
      </div>
      <div class="link-response__info">
        <div class="link-response__info--row">
          <lib-data-point style="max-width: 60%">
            <div class="title">
              <lib-text content="Empresa pagadora"></lib-text>
            </div>
            <div class="value">
              <lib-text
                size="s"
                weight="label"
                [content]="
                  (operation?.debtor?.companyName | uppercase) || '---'
                "
                [copyIcon]="false"
              >
              </lib-text>
            </div>
          </lib-data-point>
          <lib-data-point>
            <div class="title right">
              <lib-text content="Monto"></lib-text>
            </div>
            <div class="value">
              <lib-money
                color="blue"
                [currency]="operation?.currency || 'pen'"
                [amount]="'60000'"
              ></lib-money>
            </div>
          </lib-data-point>
        </div>
        <div class="link-response__info--row">
          <lib-data-point>
            <div class="title">
              <lib-text content="Empresa giradora"></lib-text>
            </div>
            <div class="value">
              <lib-text
                size="s"
                weight="label"
                [content]="
                  (operation?.issuer?.companyName | uppercase) || '---'
                "
                [copyIcon]="false"
              >
              </lib-text>
            </div>
          </lib-data-point>
          <lib-data-point>
            <div class="title right">
              <lib-text content="Fecha de pago"></lib-text>
            </div>
            <div class="value">
              <lib-text
                class="right-space"
                weight="medium"
                size="xs"
                [content]="operation?.paymentDate | formatDate"
              >
              </lib-text>
            </div>
          </lib-data-point>
        </div>
      </div>
      <div class="link-response__sub-info">
        <div *ngFor="let physicalInvoice of operation.physicalInvoices">
          <lib-data-point>
            <div class="title">
              <lib-text
                color="dark-gray"
                [content]="physicalInvoice.code | uppercase"
              ></lib-text>
            </div>
            <div class="value">
              <lib-text
                size="xs"
                weight="label"
                [content]="
                  (operation.currency === 'pen' ? 'S/ ' : '$ ') +
                  (physicalInvoice.netAmountItem | numberSpacing)
                "
                [copyIcon]="false"
              >
              </lib-text>
            </div>
          </lib-data-point>
        </div>
      </div>
    </div>
  </div>
  <div class="link-response__checks" *ngIf="operations.length">
    <div class="link-response__checks-row">
      <img
        [src]="
          contactsValidation?.validFrom
            ? '../../../../../../assets/icons/success-green.svg'
            : '../../../../../../assets/icons/failed.svg'
        "
        width="20px"
        height="20px"
      />
      <lib-text
        size="xs"
        weight="label"
        [content]="
          contactsValidation?.isFromFinsmart
            ? 'Emisor validado con excepción:'
            : 'Emisor validado:'
        "
      >
      </lib-text>
      <lib-text size="xs" weight="heading" [content]="targetReply.from">
      </lib-text>
    </div>
    <div class="link-response__checks-row">
      <img
        [src]="
          contactsValidation?.hasAllValidatedContacts
            ? '../../../../../../assets/icons/success-green.svg'
            : '../../../../../../assets/icons/failed.svg'
        "
        width="20px"
        height="20px"
      />
      <lib-text
        size="xs"
        weight="label"
        [content]="
          (contactsValidation?.hasAllValidatedContacts
            ? 'Todos los contactos validados puestos en copia: '
            : 'Contactos validados que faltan poner en copia: ') +
          arrayToString(contactsValidation?.foundedValidatedContacts)
        "
      >
      </lib-text>
    </div>
    <div class="link-response__checks-row">
      <img
        [src]="
          contactsValidation?.hasUnValidatedContacts
            ? '../../../../../../assets/icons/empty-yellow-circle.svg'
            : '../../../../../../assets/icons/success-green.svg'
        "
        width="20px"
        height="20px"
      />
      <lib-text
        size="xs"
        weight="label"
        [content]="
          contactsValidation?.hasUnValidatedContacts
            ? 'Contactos en copia que no están validados: ' +
              arrayToString(contactsValidation?.unvalidatedContacts)
            : 'No existen contactos puestos en copia que no estén validados'
        "
      >
      </lib-text>
    </div>
  </div>
  <div class="link-response__warning-message">
    <lib-text [content]="hasAllValidatedContactsMessage"></lib-text>
  </div>
  <div class="link-response__submit">
    <fs-ui-button
      [action]="'submit'"
      [isDisabled]="!validForm()"
      [label]="getButtonLabel()"
      (onClick)="submit()"
    ></fs-ui-button>
    <fs-ui-button
      (onClick)="close()"
      [label]="'Cancelar'"
      type="tertiary"
    ></fs-ui-button>
  </div>
</div>
